/*
* Angular module to handle Alternate Approvers Settings under MyAccount> Profile
*/
angular.module('App.MyAccount.AlternateApprover.Ctrl',['jv.Admin.Users.EmployeeSelect.Factory'])
.controller('myAccountAlternateApproverCtrl', ['$scope', 'employeeSelectFAC', 'myAccountProfileSvc', '$log', '$timeout', '$rootScope',
    function ($scope, employeeSelectFAC, myAccountProfileSvc, $log, $timeout, $rootScope) {
        $scope.employeeSelect = employeeSelectFAC;
        $scope.myAccount = $scope.myAccount || {};
        $scope.myAccount.alternateApprovers = {
            list: [],
            listCopy: [],
            edit: false,
            error: false,
            max: 3
        };
   
        var callOnError = function(errorMessage){
            $scope.flags.loading = false;
            $log.error(errorMessage);
        };

        $scope.myAccount.alternateApprovers.get = function() {
            $scope.flags.loading = true;
            myAccountProfileSvc.getAlternateApprovers(function(response){
                $scope.myAccount.alternateApprovers.edit = false;
                $scope.flags.loading = false;
                if(response && response.alternateApprovers) {
                    $rootScope.isAlternateApproversExists = (angular.isArray(response.alternateApprovers) && response.alternateApprovers.length > 0);
                    $scope.myAccount.alternateApprovers.placeholder = i18n['MAXIMUM'] + ' ' + $scope.myAccount.alternateApprovers.max;
                    // Adding timer event to delay multi-Select2 model initialization
                    $timeout(function(){
                        $scope.myAccount.alternateApprovers.transform(response.alternateApprovers);
                    },100);
                }
            }, callOnError);
        };

        $scope.myAccount.alternateApprovers.transform = function(userList) {
            $scope.myAccount.alternateApprovers.list = angular.copy(userList);
            $scope.myAccount.alternateApprovers.listCopy = angular.copy(userList);
            $scope.myAccount.alternateApprovers.selected = [];
            angular.forEach(userList, function(approver){
                $scope.myAccount.alternateApprovers.selected.push(approver.user);
            });
            $scope.myAccount.alternateApprovers.selectedCopy = angular.copy($scope.myAccount.alternateApprovers.selected);
        };

        $scope.myAccount.alternateApprovers.cancel = function() {
            $scope.myAccount.alternateApprovers.edit = false;
            $scope.myAccount.alternateApprovers.error = false;
            $scope.myAccount.alternateApprovers.list = angular.copy($scope.myAccount.alternateApprovers.listCopy);
            $scope.myAccount.alternateApprovers.selected = angular.copy($scope.myAccount.alternateApprovers.selectedCopy);
            $scope.myAccount.alternateApprovers.selectionError = false;
            if($scope.myAccount.alternateApprovers.set) {
                $scope.myAccount.alternateApprovers.set = false;
                $rootScope.$emit('cancelSettingApprover', {});
            }
        };

        $scope.myAccount.alternateApprovers.save = function() {
            $scope.flags.loading = true;
            var postData = {
                alternateApprovers: $scope.myAccount.alternateApprovers.prepareData($scope.myAccount.alternateApprovers.selected)
            };
            myAccountProfileSvc.saveAlternateApprovers(postData, function(response){
                $scope.flags.loading = false;
                if(response.msgInfo === 200) {
                    $scope.showMsg('DATA_SAVED');
                    if($scope.myAccount.alternateApprovers.set) {
                        $scope.myAccount.alternateApprovers.set = false;
                        $rootScope.isAlternateApproversExists = (angular.isArray(postData.alternateApprovers) && postData.alternateApprovers.length > 0);
                        if($rootScope.isAlternateApproversExists) {
                            $rootScope.$emit('approverSaved','true');
                        } else {
                            $rootScope.$emit('cancelSettingApprover', {});
                        }
                    }
                    $scope.myAccount.alternateApprovers.get();
                }
            }, callOnError);
        };

        $scope.myAccount.alternateApprovers.prepareData = function(userList) {
            var data = [];
            angular.forEach(userList, function(user){
                data.push(user.EId);
            });
            return data;
        };

        $scope.myAccount.alternateApprovers.select = function() {
            if(angular.isArray($scope.myAccount.alternateApprovers.selected)) {
                var currentSelectedUsers = angular.copy($scope.myAccount.alternateApprovers.selected);
                $scope.myAccount.alternateApprovers.error = false;

                if(currentSelectedUsers.length > $scope.myAccount.alternateApprovers.max) {
                    $scope.myAccount.alternateApprovers.selected = [];
                    currentSelectedUsers.splice(currentSelectedUsers.length-1,1);

                    $scope.myAccount.alternateApprovers.selected = angular.copy(currentSelectedUsers);
                    $scope.myAccount.alternateApprovers.error = true;
                } else if(currentSelectedUsers.length === 0) {
                    if($scope.isUserOutOfOffice) {
                        $scope.myAccount.alternateApprovers.selectionError = true;
                    }
                }
            }
        };

        $rootScope.$on('changeApprover', function(){
            $scope.myAccount.alternateApprovers.edit = true;
            $scope.myAccount.alternateApprovers.set = true;
        });

        $scope.myAccount.alternateApprovers.broadcastOutOfOffice = function(){
            $rootScope.isAlternateApproversExists = false;
            $scope.myAccount.alternateApprovers.selectionError = false;
            $scope.myAccount.alternateApprovers.set = false;
            $scope.myAccount.alternateApprovers.save();
            $rootScope.$emit('approverSaved', 'false');
        };

        $scope.myAccount.alternateApprovers.get();
    }
]);